import { SxProps, Theme } from '@mui/material';
import { ENDED_PROGRESS_GRAY } from '../../../styles/GlobalStyles';

export const studentProgressStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: 0,
    padding: 0,
  } as SxProps<Theme>,

  progressBarTrack: {
    width: '100%',
    position: 'relative',
    height: '20px',
    lineHeight: 1,
    background: 'repeating-linear-gradient(-45deg, #eeeeee, #eeeeee 2px, #f9f9f8 2px, #f9f9f8 15px)',
    backgroundSize: '100% 20px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 bottom',
    backgroundColor: '#fff',
    borderRadius: 0,
    overflow: 'hidden',
  } as SxProps<Theme>,

  scheduledDates: {
    width: '100%',
    minHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    boxSizing: 'border-box',
    fontSize: '12px',
    lineHeight: '20px',
    textAlign: 'left',
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(158, 158, 158)',
  } as SxProps<Theme>,

  progressBarFill: (progressPercentage: number, isEndedExperience: boolean = false) =>
    ({
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: `${progressPercentage}%`,
      bgcolor: isEndedExperience ? ENDED_PROGRESS_GRAY : 'primary.main',
      clipPath: 'polygon(0 0, 100% 0, calc(100% - 20px) 100%, 0 100%)',
      transition: 'width 0.2s ease',
      zIndex: 0,
    }) as SxProps<Theme>,

  runningManIcon: (progressPercentage: number, iconUrl?: string) =>
    ({
      position: 'absolute',
      left: `max(0px, calc(${progressPercentage}% - 32px))`,
      top: '50%',
      transform: 'translateY(-50%)',
      transformOrigin: 'center',
      width: '16.2px',
      height: '14.85px',
      backgroundColor: '#FFFFFF',
      maskImage: iconUrl ? `url(${iconUrl})` : undefined,
      WebkitMaskImage: iconUrl ? `url(${iconUrl})` : undefined,
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      maskPosition: 'center',
      WebkitMaskPosition: 'center',
      maskSize: 'contain',
      WebkitMaskSize: 'contain',
      zIndex: 2,
      pointerEvents: 'none',
    }) as SxProps<Theme>,

  dateRange: (isEndedExperience: boolean, progressPercentage: number) => {
    const shouldAnchorLeft = isEndedExperience && progressPercentage > 50;

    return ({
      position: 'absolute',
      left: shouldAnchorLeft ? '8px' : 'auto',
      right: shouldAnchorLeft ? 'auto' : '8px',
      top: '50%',
      transform: 'translateY(-50%)',
      whiteSpace: 'nowrap',
      fontSize: '12px',
      color: shouldAnchorLeft ? '#FFFFFF' : '#555555',
      backgroundColor: 'transparent',
      zIndex: 1,
    }) as SxProps<Theme>;
  },
};

export default studentProgressStyles;
